import request from "@/plugins/request";

// 项目技能新增
export function courseSkillAdd(params, showLoading = false) {
	return request({
		url: `skill/courseSkill/add`,
		method: "post",
		data: params,
		headers: {
			showLoading: showLoading,
		},
	});
}

// 项目技能编辑
export function courseSkillUpdate(params, showLoading = false) {
	return request({
		url: `skill/courseSkill/update`,
		method: "post",
		data: params,
		headers: {
			showLoading: showLoading,
		},
	});
}

// 项目技能删除
export function courseSkillDel(params, showLoading = false) {
	return request({
		url: `skill/courseSkill/del`,
		method: "post",
		data: params,
		headers: {
			showLoading: showLoading,
		},
	});
}

// 项目技能列表
export function courseSkillList(params, showLoading = false) {
	return request({
		url: `skill/courseSkill/list`,
		method: "post",
		data: params,
		headers: {
			showLoading: showLoading,
		},
	});
}

// 项目技能列表 已选 skill/courseSkill/getManageModule
export function courseSkillGetManageModule(params, showLoading = false) {
	return request({
		url: `skill/courseSkill/getManageModule`,
		method: "get",
		params: params,
		headers: {
			showLoading: showLoading,
		},
	});
}

// 配置包新增
export function courseSkillBundleAdd(params, showLoading = false) {
	return request({
		url: `skill/courseSkillBundle/add`,
		method: "post",
		data: params,
		headers: {
			showLoading: showLoading,
		},
	});
}

// 配置包编辑
export function courseSkillBundleUpdate(params, showLoading = false) {
	return request({
		url: `skill/courseSkillBundle/update`,
		method: "post",
		data: params,
		headers: {
			showLoading: showLoading,
		},
	});
}

// 配置包删除
export function courseSkillBundleDel(params, showLoading = false) {
	return request({
		url: `skill/courseSkillBundle/del`,
		method: "post",
		data: params,
		headers: {
			showLoading: showLoading,
		},
	});
}

// 配置包列表
export function courseSkillBundleList(params, showLoading = false) {
	return request({
		url: `skill/courseSkillBundle/list`,
		method: "post",
		data: params,
		headers: {
			showLoading: showLoading,
		},
	});
}

// 配置包导出
export function courseSkillExport(params, showLoading = false) {
	return request({
		url: `skill/courseSkill/export`,
		method: "post",
		data: params,
		headers: {
			showLoading: showLoading,
		},
	});
}

// 课程列表
export function courseInfoPageList(params, showLoading = false) {
	return request({
		url: `course/courseInfo/pageList`,
		method: "post",
		data: params,
		headers: {
			showLoading: showLoading,
		},
	});
}

// 课程配置详细新增
export function courseSkillBundleConfigDetailAdd(params, showLoading = false) {
	return request({
		url: `skill/courseSkillBundleConfigDetail/add`,
		method: "post",
		data: params,
		headers: {
			showLoading: showLoading,
		},
	});
}

// 课程配置详细编辑
export function courseSkillBundleConfigDetailUpdate(params, showLoading = false) {
	return request({
		url: `skill/courseSkillBundleConfigDetail/update`,
		method: "post",
		data: params,
		headers: {
			showLoading: showLoading,
		},
	});
}

// 课程配置详细删除
export function courseSkillBundleConfigDetailDel(params, showLoading = false) {
	return request({
		url: `skill/courseSkillBundleGroup/del`,
		method: "post",
		data: params,
		headers: {
			showLoading: showLoading,
		},
	});
}

// 获取单个课程配置详细
export function courseSkillBundleConfigDetailGet(params, showLoading = false) {
	return request({
		url: `skill/courseSkillBundleConfigDetail/getDetailByGroupId`,
		method: "post",
		data: params,
		headers: {
			showLoading: showLoading,
		},
	});
}

// 获取全部课程配置详细
export function courseSkillBundleConfigDetailGetAll(params, showLoading = false) {
	return request({
		url: `skill/courseSkillBundleConfigDetail/getGroupAllByBundleId`,
		method: "post",
		data: params,
		headers: {
			showLoading: showLoading,
		},
	});
}

// 获取签约级别
export function sysDicDataPageList(params, showLoading = false) {
	return request({
		url: `bsi/sysDicData/pageList`,
		method: "post",
		data: params,
		headers: {
			showLoading: showLoading,
		},
	});
}

// 获取角色列表
export function sysRolePage(params, showLoading = false) {
	return request({
		url: `bsi/sysRole/page`,
		method: "get",
		params: params,
		headers: {
			showLoading: showLoading,
		},
	});
}

// 新增人员配置
export function courseSkillScopeAdd(params, showLoading = false) {
	return request({
		url: `skill/courseSkillScope/add`,
		method: "post",
		data: params,
		headers: {
			showLoading: showLoading,
		},
	});
}

// 获取人员配置信息
export function courseSkillScopeInfo(params, showLoading = false) {
	return request({
		url: `skill/courseSkillScope/scopeInfo`,
		method: "post",
		data: params,
		headers: {
			showLoading: showLoading,
		},
	});
}

// 前置等级列表
export function courseSkillLevelList(params, showLoading = false) {
	return request({
		url: `skill/courseSkillLevel/list`,
		method: "post",
		data: params,
		headers: {
			showLoading: showLoading,
		},
	});
}

// 下载证书 skill/courseSkillLock/dwCert
export function courseSkillLockDwCert(params, showLoading = false) {
	return request({
		url: `skill/courseSkillLock/dwCert`,
		method: "post",
		data: params,
		headers: {
			showLoading: showLoading,
		},
	});
}

// 证书批量导出 skill/courseSkillLock/dwCertByIds
export function courseSkillLockDwCertByIds(params, showLoading = false) {
	return request({
		url: `skill/courseSkillLock/dwCertByIds`,
		method: "post",
		data: params,
		timeout: 1000 * 60 * 60, // 60分钟
		headers: {
			showLoading: showLoading,
		},
	});
}

// 新增评价逻辑
export function courseSkillLevelAdd(params, showLoading = false) {
	return request({
		url: `skill/courseSkillLevel/add`,
		method: "post",
		data: params,
		headers: {
			showLoading: showLoading,
		},
	});
}

// 编辑评价逻辑
export function courseSkillLevelUpdate(params, showLoading = false) {
	return request({
		url: `skill/courseSkillLevel/update`,
		method: "post",
		data: params,
		headers: {
			showLoading: showLoading,
		},
	});
}

// 删除评价逻辑
export function courseSkillLevelDel(params, showLoading = false) {
	return request({
		url: `skill/courseSkillLevel/del`,
		method: "post",
		data: params,
		headers: {
			showLoading: showLoading,
		},
	});
}

// 获取MIF类型
export function listByCodesPerm(params, showLoading = false) {
	return request({
		url: `bsi/sysDicData/listByCodesPerm`,
		method: "post",
		data: params,
		headers: {
			showLoading: showLoading,
		},
	});
}

// 评价逻辑详细新增/编辑
export function courseSkillLevelUD(params, showLoading = false) {
	return request({
		url: `skill/courseSkillLevel/updateDetail`,
		method: "post",
		data: params,
		headers: {
			showLoading: showLoading,
		},
	});
}

// 评价逻辑单个查询
export function courseSkillDetailById(params, showLoading = false) {
	return request({
		url: `skill/courseSkillLevel/getDetailById`,
		method: "post",
		data: params,
		headers: {
			showLoading: showLoading,
		},
	});
}

// mif列表
export function courseSkillMifPageList(params, showLoading = false) {
	return request({
		url: `skill/courseSkillMif/pageList`,
		method: "post",
		data: params,
		headers: {
			showLoading: showLoading,
		},
	});
}

// mif编辑
export function courseSkillMifUpdate(params, showLoading = false) {
	return request({
		url: `skill/courseSkillMif/update`,
		method: "post",
		data: params,
		headers: {
			showLoading: showLoading,
		},
	});
}

// mif删除
export function courseSkillMifDel(params, showLoading = false) {
	return request({
		url: `skill/courseSkillMif/del`,
		method: "post",
		data: params,
		headers: {
			showLoading: showLoading,
		},
	});
}

// mif下载模板
export function courseSkillMifExportTemp(params, showLoading = false) {
	return request({
		url: `skill/courseSkillMif/exportTemp`,
		method: "post",
		data: params,
		headers: {
			showLoading: showLoading,
		},
	});
}

// mif导入
export function courseSkillMifImport(params, showLoading = false) {
	return request({
		url: `skill/courseSkillMif/import`,
		method: "post",
		data: params,
		headers: {
			showLoading: showLoading,
		},
	});
}

// 其它列表
export function courseSkillScorePageList(params, showLoading = false) {
	return request({
		url: `skill/courseSkillScore/pageList`,
		method: "post",
		data: params,
		headers: {
			showLoading: showLoading,
		},
	});
}

// 其它编辑
export function courseSkillScoreUpdate(params, showLoading = false) {
	return request({
		url: `skill/courseSkillScore/update`,
		method: "post",
		data: params,
		headers: {
			showLoading: showLoading,
		},
	});
}

// 其它删除
export function courseSkillScoreDel(params, showLoading = false) {
	return request({
		url: `skill/courseSkillScore/del`,
		method: "post",
		data: params,
		headers: {
			showLoading: showLoading,
		},
	});
}

// 其它下载模板
export function courseSkillScoreExportTemp(params, showLoading = false) {
	return request({
		url: `skill/courseSkillScore/exportTemp`,
		method: "post",
		data: params,
		headers: {
			showLoading: showLoading,
		},
	});
}

// 其它导入
export function courseSkillScoreImport(params, showLoading = false) {
	return request({
		url: `skill/courseSkillScore/import`,
		method: "post",
		data: params,
		headers: {
			showLoading: showLoading,
		},
	});
}

// 技能锁定列表
export function courseSkillLockPageList(params, showLoading = false) {
	return request({
		url: `skill/courseSkillLock/pageList`,
		method: "post",
		data: params,
		headers: {
			showLoading: showLoading,
		},
	});
}

// 技能锁定开始认证
export function courseSkillLockStart(params, showLoading = false) {
	return request({
		url: `skill/courseSkillLock/start`,
		method: "post",
		data: params,
		headers: {
			showLoading: showLoading,
		},
	});
}

// 锁定认证结果
export function courseSkillLockResult(params, showLoading = false) {
	return request({
		url: `skill/courseSkillLock/lockResult`,
		method: "post",
		data: params,
		headers: {
			showLoading: showLoading,
		},
	});
}

// 回到上一次锁定认证结果
export function courseSkillLockResultBack(params, showLoading = false) {
	return request({
		url: `skill/courseSkillLock/lockResultBack`,
		method: "post",
		data: params,
		headers: {
			showLoading: showLoading,
		},
	});
}

// 获取单个技能信息
export function courseSkillInfo(id, showLoading = false) {
	return request({
		url: `skill/courseSkill/info/${id}`,
		method: "get",
		headers: {
			showLoading: showLoading,
		},
	});
}

// 新增显示名称
export function courseSkillShowAdd(params, showLoading = false) {
	return request({
		url: `skill/courseSkillShow/add`,
		method: "post",
		data: params,
		headers: {
			showLoading: showLoading,
		},
	});
}

// 编辑显示名称
export function courseSkillShowUpdate(params, showLoading = false) {
	return request({
		url: `skill/courseSkillShow/update`,
		method: "post",
		data: params,
		headers: {
			showLoading: showLoading,
		},
	});
}

// 删除显示名称
export function courseSkillShowDel(params, showLoading = false) {
	return request({
		url: `skill/courseSkillShow/del`,
		method: "post",
		data: params,
		headers: {
			showLoading: showLoading,
		},
	});
}

// 显示名称列表
export function courseSkillShowList(params, showLoading = false) {
	return request({
		url: `skill/courseSkillShow/list`,
		method: "post",
		data: params,
		headers: {
			showLoading: showLoading,
		},
	});
}

// 年度评价历史
export function courseSkillLockHistory(params, showLoading = false) {
	return request({
		url: `skill/courseSkillLock/lockHis`,
		method: "post",
		data: params,
		headers: {
			showLoading: showLoading,
		},
	});
}

// 导出
export function courseSkillLockExport(params, showLoading = false) {
	return request({
		url: `skill/courseSkillLock/export`,
		method: "post",
		data: params,
		timeout: 1000 * 60 * 60, // 60分钟
		headers: {
			showLoading: showLoading,
		},
	});
}

// 批量认证
export function courseSkillLockImport(params, showLoading = false) {
	return request({
		url: `skill/courseSkillLock/batchLockImport`,
		method: "post",
		data: params,
		headers: {
			showLoading: showLoading,
		},
	});
}

// 人工认证
export function courseSkillLockManual(params, showLoading = false) {
	return request({
		url: `skill/courseSkillLock/lockManual`,
		method: "post",
		data: params,
		headers: {
			showLoading: showLoading,
		},
	});
}

// 经销商列表
export function courseSkillAgentList(params, showLoading = false) {
	return request({
		url: `skill/courseSkillScope/agentList`,
		method: "post",
		data: params,
		headers: {
			showLoading: showLoading,
		},
	});
}

// 用户列表
export function courseSkillUserList(params, showLoading = false) {
	return request({
		url: `skill/courseSkillScope/userList`,
		method: "post",
		data: params,
		headers: {
			showLoading: showLoading,
		},
	});
}

// 经销商显示名分组
export function courseSkillTotalView(params, showLoading = false) {
	return request({
		url: `skill/courseSkillLevel/skillTotalView`,
		method: "post",
		data: params,
		headers: {
			showLoading: showLoading,
		},
	});
}

// 显示名分组-查看具体人
export function courseSkillTotalViewUserList(params, showLoading = false) {
	return request({
		url: `skill/courseSkillLevel/skillTotalViewUserList`,
		method: "post",
		data: params,
		headers: {
			showLoading: showLoading,
		},
	});
}

// 经销商显示名分组-技能分组
export function courseSkillDetailView(params, showLoading = false) {
	return request({
		url: `skill/courseSkillLevel/skillDetailView`,
		method: "post",
		data: params,
		headers: {
			showLoading: showLoading,
		},
	});
}

// 经销商课程包分组
export function courseSkillBundleView(params, showLoading = false) {
	return request({
		url: `skill/courseSkillLevel/bundleView`,
		method: "post",
		data: params,
		headers: {
			showLoading: showLoading,
		},
	});
}

// 经销商课程包课程列表
export function courseSkillBundleCourseView(params, showLoading = false) {
	return request({
		url: `skill/courseSkillLevel/bundleCourseView`,
		method: "post",
		data: params,
		headers: {
			showLoading: showLoading,
		},
	});
}

// 经销商课程考试明细
export function courseSkillResultView(params, showLoading = false) {
	return request({
		url: `skill/courseSkillLevel/courseResultView`,
		method: "post",
		data: params,
		headers: {
			showLoading: showLoading,
		},
	});
}

// 学员显示名和技能通过情况
export function courseSkillTotalViewPerson(params, showLoading = false) {
	return request({
		url: `skill/courseSkillLevel/skillTotalViewPerson`,
		method: "post",
		data: params,
		headers: {
			showLoading: showLoading,
		},
	});
}
// 学员课程包分组
export function courseSkillBundleViewPerson(params, showLoading = false) {
	return request({
		url: `skill/courseSkillLevel/bundleViewPerson`,
		method: "post",
		data: params,
		headers: {
			showLoading: showLoading,
		},
	});
}
// 学员课程包课程列表
export function courseSkillBundleCourseViewPerson(params, showLoading = false) {
	return request({
		url: `skill/courseSkillLevel/bundleCourseViewPerson`,
		method: "post",
		data: params,
		headers: {
			showLoading: showLoading,
		},
	});
}
// 学员添加期望开课
export function courseSkillExpectAdd(params, showLoading = false) {
	return request({
		url: `skill/courseSkillExpect/add`,
		method: "post",
		data: params,
		headers: {
			showLoading: showLoading,
		},
	});
}
// 导出期望开课信息
export function courseSkillExpectExport(params, showLoading = false) {
	return request({
		url: `skill/courseSkillLock/exportExpect`,
		method: "post",
		data: params,
		headers: {
			showLoading: showLoading,
		},
	});
}

// 获取角色是否可查看技能
export function getSkillModule(params, showLoading = false) {
	return request({
		url: `skill/courseSkill/getSkillModule`,
		method: "get",
		params: params,
		headers: {
			showLoading: showLoading,
		},
	});
}

// 获取当前人的认定等级
export function getUserLockLevelName(params, showLoading = false) {
	return request({
		url: `skill/courseSkillLevel/getUserLockLevelName`,
		method: "post",
		data: params,
		headers: {
			showLoading: showLoading,
		},
	});
}

// 其它数据导出
export function courseSkillScoreExport(params, showLoading = false) {
	return request({
		url: `skill/courseSkillScore/export`,
		method: "post",
		data: params,
		headers: {
			showLoading: showLoading,
		},
	});
}

// MFI导出
export function courseSkillMifExport(params, showLoading = false) {
	return request({
		url: `skill/courseSkillMif/export`,
		method: "post",
		data: params,
		headers: {
			showLoading: showLoading,
		},
	});
}

// 获取其它证书列表
export function otherCertList(params, showLoading = false) {
	return request({
		url: `skill/courseSkillScore/getOtherCert`,
		method: "post",
		data: params,
		headers: {
			showLoading: showLoading,
		},
	});
}

// 删除其它证书
export function deletCert(params, showLoading = false) {
	return request({
		url: `bsi/sysAttachFile/delete`,
		method: "post",
		data: params,
		headers: {
			showLoading: showLoading,
		},
	});
}
